<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <div class="d-flex">
        <div class="d-flex" style="margin-right: 10px;">
          <el-avatar shape="square" :src="formData.memImgUrl" :size="64">
            <span style="font-size: 30px;">U</span>
          </el-avatar>
        </div>
        <el-row :gutter="10" class="flex-grow-1">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_userName') || '团队成员'"
              prop="userCode"
            >
              <dict-select
                v-model="formData.userCode"
                :selectedLabel.sync="formData.userName"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_user') || '请选择团队成员'"
                clearable
                filterable
                @change="userChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_userPost') || '职务'">
              <el-input v-model="formData.userPost" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_mobileNumber') || '联系电话'">
              <el-input v-model="formData.mobileNumber" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item :label="$l('form_label_emailAddress') || '邮件地址'">
            <el-input v-model="formData.emailAddress" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_fixedTelephone') || '固定电话'">
            <el-input v-model="formData.fixedTelephone" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_orgName') || '所属公司'">
            <el-input v-model="formData.orgName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_depFullName') || '所属部门'">
            <el-input v-model="formData.depFullName" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/api/service'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { listCustBizTeamSetCode: { type: Array, default: () => [] } },
  data() {
    return {
      formData: {
        userCode: '',
        userName: '',
        userPost: '',
        mobileNumber: '',
        emailAddress: '',
        fixedTelephone: '',
        orgName: '',
        depFullName: '',
        memImgUrl: '',
      },
      backDialogVisible: false,
      rules: {
        userCode: [
          {
            required: true,
            message: this.$l('form_placeholder_user') || '请选择团队成员',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async userChange(userCode) {
      const getUserInfo = async () => {
        if (!userCode) return {}
        const res = await request({
          url: '/sys/user/detail',
          method: 'POST',
          data: { userCode },
        }).catch(() => null)
        if (!res) return
        return res.body || {}
      }

      const data = await getUserInfo()
      this.formData.userPost = data.userPost
      this.formData.mobileNumber = data.mobileNumber
      this.formData.emailAddress = data.emailAddress
      this.formData.fixedTelephone = data.fixedTelephone
      this.formData.orgName = data.orgName
      this.formData.depFullName = data.depFullName
      this.formData.memImgUrl = data.memImgUrl
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const confirm = await this.$confirm(
        `${this.$l('tips_confirm_changeUser') ||
          '是否将所选客户业务人员修改为: '}<span style="color:#409EFF;font-weight: bold;">
            ${this.formData.userName}
        </span>`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const params = {
        listCustBizTeamSetCode: this.listCustBizTeamSetCode,
        ...this.formData,
      }
      this.loadingOpen()
      const res = await this.$api
        .masterCustomerBizTeamSetChangeUserApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '更新失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '更新成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style scoped></style>
